export const LEGAL_CONSENT_FIELD = "legalConsent";
export const LEGAL_CONSENT_ERROR = "legalConsentRequired";

export function isLegalConsentAccepted(
  value: FormDataEntryValue | boolean | null | undefined,
): boolean {
  if (value === true) {
    return true;
  }
  if (typeof value !== "string") {
    return false;
  }
  const normalized = value.trim().toLowerCase();
  return (
    normalized === "on" ||
    normalized === "true" ||
    normalized === "1" ||
    normalized === "accepted"
  );
}

export function requireLegalConsent(
  value: FormDataEntryValue | boolean | null | undefined,
): void {
  if (!isLegalConsentAccepted(value)) {
    throw new Error(LEGAL_CONSENT_ERROR);
  }
}
